import { observer } from 'mobx-react';
import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import appStyle from './App.module.scss';
import Header from './components/header/Header';
import Router from './router/Router';
import Footer from './components/footer/Footer';
import Loader from './components/elements/loader/Loader';
import Toast from './components/elements/toast/Toast';
import ScrollToTop from './components/elements/scrollToTop/ScrollToTop';
import ProtfolioStore from './stores/protfolio/Protfolio.store';
import { PROTFOLIO_STORE } from './stores/constants';
import rootStores from './stores/index';
import { Languages } from './emuns/enums';
import { SpeedInsights } from '@vercel/speed-insights/react';

const protfolioStore = rootStores[PROTFOLIO_STORE] as ProtfolioStore;

const App = observer(() => {
    const { isLoading } = protfolioStore;

    const {
        t,
        i18n: { language },
    } = useTranslation();

    return (
        <BrowserRouter>
            <div
                className={`${appStyle.app} ${language === Languages.HEBREW ? appStyle.he : ''}`}
                dir={language === Languages.HEBREW ? 'rtl' : 'ltr'}
            >
                <SpeedInsights />
                <ScrollToTop />

                <a className={appStyle.skipLink} href='#main'>
                    {t('header.skipToContent')}
                </a>

                <Header />

                <main id='main' className={appStyle.main}>
                    <Router />
                </main>

                <Footer />
                <Toast />

                {isLoading && <Loader />}
            </div>
        </BrowserRouter>
    );
});

export default App;
